import { motion } from 'framer-motion';

export const InfoCardSkeleton = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className='rounded-lg border border-outline-variant bg-white p-6'
    >
      <div className='flex gap-6'>
        {/* Image placeholder */}
        <div className='h-20 w-20 animate-pulse rounded-lg bg-gray-200' />

        <div className='flex-1 space-y-3'>
          {/* Title */}
          <div className='h-7 w-64 animate-pulse rounded bg-gray-200' />

          {/* Subtitle */}
          <div className='h-4 w-40 animate-pulse rounded bg-gray-200' />

          {/* Fields */}
          <div className='grid grid-cols-2 gap-4'>
            <div className='space-y-2'>
              <div className='h-3 w-16 animate-pulse rounded bg-gray-200' />
              <div className='h-4 w-24 animate-pulse rounded bg-gray-200' />
            </div>
            <div className='space-y-2'>
              <div className='h-3 w-20 animate-pulse rounded bg-gray-200' />
              <div className='h-4 w-32 animate-pulse rounded bg-gray-200' />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
